<!-- Job List View -->
<app-job-follow-up
    *ngIf="!showEmailView"
    [cycleId]="cycleId"
    [title]="title"
    [jobGroup]="jobGroup"
    [pageComponentName]="pageComponentName"
    [filterByPage]="filterByPage"
    (emailRequested)="onEmailRequested($event)"
></app-job-follow-up>

<!-- Email Send View -->
<app-email-send-modal
    *ngIf="showEmailView && isEmailFeatureEnabled"
    [job]="selectedJob"
    [isStandalone]="true"
    (goBackRequested)="onGoBackToJobList()"
    (emailSentSuccess)="onEmailSent()"
    (closeRequested)="close()"
></app-email-send-modal>
